import { FC } from 'react';
import styles from './CountBadge.module.scss';

type CountBadgeProps = {
    count: number;
};

export const CountBadge: FC<CountBadgeProps> = ({ count }) => {
    if (!count) return null;

    return <span className={styles.badge}>{count}</span>;
};

export default CountBadge;
